import React, { Component } from 'react';
import { Link } from "react-router-dom";

export class Home extends Component {
  render () {
    return (
          <div>
                <h1>WebMD Provider Services CTA Gateway</h1>
                <p>This is the web app that users will land on when scanning a QR code, or clicking on a link in an SMS message, from WebMD TV.</p>
                <p>Actual users won't land on this Home page; because they'll present query params that will identify a specific <Link to="/campaign">Campaign</Link>.</p>
          </div>
    );
  }
}
